export enum AsicAgentStatus {
  Ok = 0,
  PasswordIncorrect = 1,
  AccountLocked = 2
}
